import React from 'react';
import {Body} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import {CampaignListItem} from '@/hooks/queries/use-campaigns-v2-list-query/useCampaignsV2ListQuery';
import CampaignCard from '../campaign-card/CampaignCard';
import styles from './CampaignCardList.module.scss';

interface CampaignCardListProps {
  campaigns: CampaignListItem[];
}

export default function CampaignCardList({campaigns}: CampaignCardListProps) {
  if (campaigns.length === 0) {
    return (
      <div className={styles.empty}>
        <Body size="md">{translate('No campaigns found')}</Body>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {campaigns.map((campaign) => (
        <CampaignCard key={campaign.id} campaign={campaign} />
      ))}
    </div>
  );
}
